// @flow

import * as React from 'react';

import { useTranslator } from '@gandi/translate';
import { Hide, IconButton, Button } from '@gandi/ui';

type Props = {
  addedToCart?: boolean,
  loading?: boolean,
  isCartActionnable?: boolean,
  onClick: (evt: SyntheticMouseEvent<>) => Promise<void> | mixed,
};

export function CartButton({
  addedToCart,
  loading,
  isCartActionnable,
  onClick,
}: Props): React.MixedElement | null {
  const { __ } = useTranslator();
  const icon = addedToCart && !loading ? 'checkmark' : 'cart';
  const label = addedToCart ? __('Remove from cart') : __('Add to cart');

  const props = {
    onClick,
    disabled: !isCartActionnable,
    intent: addedToCart && !loading ? 'success' : undefined,
    loading,
  };

  if (!isCartActionnable && !loading && !addedToCart) {
    return null;
  }

  return (
    <div>
      <Hide from="sm">
        <IconButton icon={icon} {...props}>
          {label}
        </IconButton>
      </Hide>
      <Hide until="sm">
        <Button iconBefore={icon} {...props}>
          {label}
        </Button>
      </Hide>
    </div>
  );
}
